/* ===== Application Configuration ===== */

export const APP_CONFIG = {
  name: import.meta.env.VITE_APP_NAME || 'Zetyar Nexo',
  tagline: 'Conecta personas, proyectos y organizaciones.',
  locale: import.meta.env.VITE_DEFAULT_LOCALE || 'es-CL',
  currency: import.meta.env.VITE_DEFAULT_CURRENCY || 'CLP',
  timezone: import.meta.env.VITE_DEFAULT_TIMEZONE || 'America/Santiago',
  environment: import.meta.env.VITE_APP_ENV || 'development',
} as const

export const SUPABASE_CONFIG = {
  url: import.meta.env.VITE_SUPABASE_URL,
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
} as const

export const PAGINATION = {
  defaultPageSize: 20,
  maxPageSize: 100,
  chatMessageLimit: 50,
} as const

export const FILE_LIMITS = {
  maxFileSizeMb: 10,
  maxFileSizeBytes: 10 * 1024 * 1024,
  allowedImageTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  allowedDocumentTypes: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/plain',
    'text/csv',
  ],
  allowedTypes: [] as string[], // populated below
} as const

// Merge allowed types
;(FILE_LIMITS.allowedTypes as string[]).push(
  ...FILE_LIMITS.allowedImageTypes,
  ...FILE_LIMITS.allowedDocumentTypes,
)

export { ROLES, PERMISSIONS, ROLE_PERMISSIONS } from '@zetyar/domain'
